<template>
  <div class="recruitingAdd">
    <div class="classify_box" @click="handleblur">
      <el-form :model="ruleForm" :rules="rules" status-icon ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="用户名:" prop="username">
          <el-input v-model="ruleForm.username"></el-input>
        </el-form-item>

        <el-form-item label="状态:" prop="status">
          <el-radio-group v-model="ruleForm.status">
            <el-radio :label="1">在职</el-radio>
            <el-radio :label="2">离职</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="部门:">  <!-- prop="departments" -->
            <el-checkbox-group v-model="ruleForm.departments" @change="departmentChange">
              <el-checkbox :label="item.name" v-for="(item,index) in departmentList" :key='index'></el-checkbox>
            </el-checkbox-group>
        </el-form-item>

        <el-form-item label="部门类型:" prop="departmenttype">
          <el-select clearable v-model="ruleForm.departmenttypes" placeholder="请选择部门类型" @change='departmenttypeChange'>
            <el-option  label="全部" value="1"></el-option>
            <el-option  label="分部" value="2"></el-option>
            <el-option  label="个人" value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="邮箱" :rules="[
            { required: true, message: '请输入邮箱地址', trigger: 'blur' },
            {
              type: 'email',
              message: '请输入正确的邮箱地址',
              trigger: ['blur', 'change'],
            },
          ]"
          prop="email">
          <el-col :span="24">
            <div class="email_box">
              <el-input v-model="ruleForm.email" @input="handleFocus"></el-input>
              <div class="email_list" v-if="focusVal == 1">
                <div v-for="(items, index) in emailList" :key="index" @click="handleVal(ruleForm.email + items.email)">
                  {{ ruleForm.email + items.email }}
                </div>
              </div>
            </div>
          </el-col>
        </el-form-item>

        <el-form-item label="电话:" prop="mobile">
          <el-input type="number" v-model="ruleForm.mobile"></el-input>
        </el-form-item>

        <el-form-item label="密码:" prop="password">
          <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="再次输入密码:" prop="repassword">
          <el-input type="password" v-model="ruleForm.repassword" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="客服账号:" prop="mobileaccount">
          <el-input v-model="ruleForm.mobileaccount"></el-input>
        </el-form-item>

        <el-form-item label="客服密码:" prop="mobilepwd">
          <el-input v-model="ruleForm.mobilepwd"></el-input>
        </el-form-item>

        <el-form-item label="QQ号:" prop="qq">
          <el-input type="number" v-model="ruleForm.qq"></el-input>
        </el-form-item>

        <el-form-item label="所属角色:" prop="role_id">
          <el-select clearable v-model="ruleForm.role_id" placeholder="所属角色">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="关联内部职工:">
          <el-select clearable v-model="ruleForm.utypeid" placeholder="请选择内部员工" @change='workerChange'>
            <el-option v-for='(item,index) in workerList' :key='index' :label="item.oausername" :value="item.id"></el-option>

          </el-select>
        </el-form-item>


        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          <el-button @click="handleGo">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import {
    Message
  } from "element-ui";
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (this.id) {
          if (this.ruleForm.repassword !== "") {
            this.$refs.ruleForm.validateField("repassword");

            callback();
          }
        } else {
          if (value === "") {
            callback(new Error("请输入密码"));
          } else {
            if (this.ruleForm.repassword !== "") {
              this.$refs.ruleForm.validateField("repassword");
            }
            callback();
          }
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (this.id) {
          if (value === "") {
            callback(new Error("请再次输入密码"));
          } else if (value !== this.ruleForm.password) {
            callback(new Error("两次输入密码不一致!"));
          } else {
            callback();
          }
        } else {
          if (value !== this.ruleForm.password) {
            callback(new Error("两次输入密码不一致!"));
          } else {
            callback();
          }
        }
      };
      return {
        ruleForm: {
          password: "",
          repassword: "",
          departments:[],
          role_id:'',

        },
        rules: {
          password: [{
            validator: validatePass,
            trigger: "blur"
          }],

          repassword: [{
            validator: validatePass2,
            trigger: "blur"
          }],
          username: [{
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }, ],
          email: [{
            required: true,
            message: "请输入电子邮件",
            trigger: "blur"
          }],
          mobile: [{
            required: true,
            message: "请输入电话",
            trigger: "blur"
          }],
          role_id: [{
            required: true,
            message: "请选择所属角色",
            trigger: "blur"
          }, ],
          status: [{
            required: true,
            message: "请选择角色状态",
            trigger: "change"
          }, ],
          departmenttype: [{
            required: true,
            message: "请选择部门类型",
            trigger: "change"
          }, ],
          departments: [{
            required: true,
            message: "请选择部门",
            trigger: "change"
          }, ]
        },
        id: "",
        options: [],
        emailList: [{
            email: "@163.com",
          },
          {
            email: "@qq.com",
          },
          {
            email: "@126.com",
          },
          {
            email: "@hotmail.com",
          },
          {
            email: "@gmail.co",
          },
          {
            email: "@yahoo.com",
          },
          {
            email: "@sina.com",
          },
        ],
        focusVal: 0,
        departmentList:[],
        workerList:[]
      };
    },
    activated() {
      this.gets("public/rolelist").then((res) => {
        this.options = res.data.data;
      });
      this.id = this.$route.query.id;
      this.getDepartment()
      this.getWorkerList()
      if (this.id) {
        this.gets('oasystem/departmentlist').then(res=>{
          this.departmentList = res.data.data
          this.getInfo();
        })
      }
    },
    methods: {
      getWorkerList(){
        this.gets('oasystem/cateadminlist').then(res=>{
            res.data.data.map((item)=>{
              item.id = item.id +''
              this.workerList.push(item)
            })
        })
      },

      workerChange(e){
        let selectItem = {}
        this.workerList.map((item)=>{
          if(item.id == e){
            selectItem = item
          }
        })
        this.ruleForm.utypeid = selectItem.id
        this.ruleForm.oausername = selectItem.oausername
        this.ruleForm.uid = selectItem.uid
      },

      handleblur() {
        this.focusVal = 0;
      },
      handleVal(val) {
        this.ruleForm.email = val;
        this.focusVal = 0;
      },

      departmenttypeChange(val){
        this.ruleForm.departmenttype = val
        this.ruleForm.departmenttypes = val==1?'全部':(val==2?'分部':(val==3?'个人':''))
        this.$forceUpdate()
      },

      departmentChange(){
        let list = []
        this.ruleForm.departments.map((item)=>{
          this.departmentList.map((items)=>{
              if(items.name == item){
                list.push(items.id)
                return list
              }
              return list
          })
          return list
        })
        this.ruleForm.department = list
        this.$forceUpdate()
      },

      getDepartment(){
        this.gets('oasystem/departmentlist').then(res=>{
          this.departmentList = res.data.data
        })
      },
      //邮箱
      handleBlur() {
        this.focusVal = 0;
      },
      handleFocus() {
        if (this.ruleForm.email.indexOf("@") >= 0) {
          this.focusVal = 0;
        } else {
          this.focusVal = 1;
        }
      },
      getInfo() {
        this.gets("admin/edit?id=" + this.id).then((res) => {
          this.ruleForm = res.data.data;
          let list = []
          res.data.data.utypeid = res.data.data.utypeid + ''
          res.data.data.department.map((item)=>{
            this.departmentList.map((items)=>{
              if(item == items.id){
                list.push(items.name)
                return list
              }
              return list
            })
            return list
          })
          this.ruleForm.departments = list
          this.ruleForm.departmenttypes = res.data.data.departmenttype==1?'全部':res.data.data.departmenttype==2?'分部':''
        });
      },
      handleGo() {
        this.$router.go(-1);
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.id) {
              if (!this.ruleForm.password) {
                this.ruleForm.password = "";
              }
              this.post("admin/edit", this.ruleForm).then((res) => {
                if (res.data.code == 1) {
                  Message.success(res.data.msg);
                  var that = this;
                  setTimeout(function() {
                    that.$router.go(-1);
                  }, 1000);
                } else {
                  Message.error(res.data.msg);
                }
              });
            } else {
              this.post("admin/add", this.ruleForm).then((res) => {
                if (res.data.code == 1) {
                  Message.success(res.data.msg);
                  var that = this;
                  setTimeout(function() {
                    that.$router.go(-1);
                  }, 1000);
                } else {
                  Message.error(res.data.msg);
                }
              });
            }
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/system/AdminindexAdd.vue